import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '~/common/components/PageTitle';
import OnboardingFormContainer from '../containers/OnboardingForm';

const OnboardingForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('A11y CI/CD Tools Assignment Form')} />
      <OnboardingFormContainer />
    </>
  );
};

export default OnboardingForm;
